import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { AuthService } from '@auth0/auth0-angular';
import { switchMap } from 'rxjs/operators';

import { WORKSPACE_GATEWAY_URL } from './workspace-gateway-url';

/**
 * Attaches the Auth0 bearer token to workspace-gateway (document-store) calls.
 *
 * Which URLs count as gateway traffic lives in `workspace-gateway-url.ts`.
 *
 * None of these target `environment.apiUrl` / `graphqlUrl`, so the shared `AuthInterceptor`
 * skips them. The SSE stream authenticates separately inside the chat package — its `fetch`
 * bypasses HttpClient, so it takes the bearer via `getStreamHeaders`.
 */
export const aiWorkspaceAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (!WORKSPACE_GATEWAY_URL.test(req.url)) {
    return next(req);
  }

  const auth = inject(AuthService);
  return auth.getAccessTokenSilently().pipe(switchMap((token) => next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }))));
};
